export const USAGE_REFRESH_EVENT = 'nt-usage-refresh';

/**
 * Emit usage refresh event
 * @param {Object} payload
 * @param {'email'|'brief'|'competitor'} payload.tool
 * @param {'basic'|'deep'} payload.mode
 */
export const emitUsageRefresh = ({ tool, mode }) => {
  window.dispatchEvent(
    new CustomEvent(USAGE_REFRESH_EVENT, {
      detail: { tool, mode },
    })
  );
};
